








































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { billingService } from '@/services/BillingService';
import EventBus from '@/EventBus';
import TooltipBox from '@/components/common/TooltipBox.vue';
import { pricesService } from '@/services/PricesService';
import PriceWithCurrency from '@/components/common/PriceWithCurrency.vue';
import { currencyService } from '@/services/CurrencyService';

@Component({
  components: {
    TooltipBox,
    PriceWithCurrency,
  },
  props: ['isInSettings'],
})
export default class Menu extends Vue {
  isNetworkMenuActive = false;
  workspaceId = 0;
  regionId = 0;
  currentRegion: any = {};
  monthlyUpload = 0;
  bandwidthPrice = 0;
  limits: any = {};
  priceModifier = 0.00001;
  isModuleFinished: boolean = false;
  currency: string = '';

  @Watch('$route.params.workspaceId')
  onWorkspaceChange() {
    this.update();
  }
  @Watch('$route.params.regionId')
  onRegionChange() {
    this.update();
  }

  @Watch('$store.state.regions.regions', { immediate: true, deep: true })
  onRegionsChange() {
    this.currentRegion = this.$store.getters['regions/getCurrentRegion'];
  }

  @Watch('$store.state.currentWorkspace.limits', { immediate: true, deep: true })
  onLimitsChange(data: any) {
    this.limits = data;
  }

  toggleNetworkMenu() {
    this.isNetworkMenuActive = !this.isNetworkMenuActive;
  }
  mounted() {
    this.update();
    const networkMenuPaths = [
      `/workspaces/${this.workspaceId}/regions/${this.regionId}/public-ip-addresses`,
      `/workspaces/${this.workspaceId}/regions/${this.regionId}/private-networks`,
      `/workspaces/${this.workspaceId}/regions/${this.regionId}/firewall`,
    ];
    for (let path of networkMenuPaths) {
      if (this.$route.path.toLowerCase().includes(path)) {
        this.isNetworkMenuActive = true;
      }
    }
    EventBus.$on('update-bandwidth', (payload: any) => {
      if (
        this.workspaceId === payload.workspace_region.workspace_id &&
        this.regionId === payload.workspace_region.region_id
      ) {
        this.monthlyUpload = payload.monthly_upload;
      }
    });
  }
  private update() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.regionId = parseInt(this.$route.params.regionId, 10);
    if (this.regionId) {
      billingService
        .bandwidthMonthlyUpload(this.workspaceId, this.regionId)
        .then((data: any) => {
          this.monthlyUpload = data && data.monthly_upload ? data.monthly_upload : 0;
        })
        .catch(() => {});
      currencyService.getCurrency(this.workspaceId).then((currency: string) => {
        this.currency = currency;
      });
      pricesService.getPrices(this.workspaceId, this.regionId).then((data: any) => {
        const temp = data.filter((item: any) => item.resource === 'upload' && item.currency === this.currency);
        this.bandwidthPrice = temp[0];
      });
    }
  }
}
